var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "currentCColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08511 8.84302L5.71277 5.04941C5.81915 4.96221 5.89362 4.875 5.93617 4.78779C5.97872 4.70058 6 4.60465 6 4.5C6 4.39535 5.97872 4.29942 5.93617 4.21221C5.89362 4.125 5.81915 4.03779 5.71277 3.95058L1.08511 0.156977C1.02128 0.104651 0.951915 0.0655815 0.877021 0.0397675C0.802128 0.0139536 0.722553 0.000697674 0.638298 0C0.468085 0 0.319149 0.0481395 0.191489 0.144419C0.0638289 0.240698 0 0.366976 0 0.523255V8.47674C0 8.63371 0.0638289 8.76034 0.191489 8.85662C0.319149 8.9529 0.468085 9.00069 0.638298 8.99999C0.680851 8.99999 0.829788 8.94767 1.08511 8.84302Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightV2);
export default __webpack_public_path__ + "static/media/arrow_right_v2.6eea645dd70d5c995317a8ba19fdf417.svg";
export { ForwardRef as ReactComponent };